import React from 'react';

function NotFound(props) {
    return (
        <main className={`flex items-center h-screen`}>
            <div className={`text-center`}>
            <p
            className={`text-white text-2xl`}
            >There's nothing here yet</p>
            
            <p
            className={`text-white text-xl`}
            >Exciting things to come</p>
            </div>
        </main>
    );
}

export default NotFound;